/**
 * Constants file for copy within ListingsLaunch related ExternalAccounts components
 *
 * @author Ahsan Qureshi (aqureshi@yext.com)
 */
goog.declareModuleId('yext.externalaccounts.listingslaunch.copyconstants');

export const ACCOUNT_LOADING_CONTENT = yext.msg(
  'Your publisher account is being linked. Do not close this window. It will close automatically once the account is linked.');
export const ACCOUNT_LOADING_TITLE = yext.msg('Connecting Your Account');
export const ADD_LINKED_ACCOUNT_MODAL_CTA_CANCEL = yext.msg('Cancel Linking');
export const ADD_LINKED_ACCOUNT_MODAL_TITLE = yext.msg('Linking Your Account');
export const ADD_LINKED_ACCOUNT_MODAL_CONTENT = yext.msg(
  'After linking your account in the popup, please wait for this page to reload. Do not close this window.');
export const COLUMN_LABEL_ACCOUNT_NAME = yext.msg('Account Name');
export const COLUMN_LABEL_EMAIL = yext.msg('Email');
export const CREATE_ACCOUNT_BUTTON = yext.msg('Create Account');
// TRANSLATORS: The argument is the name of a publisher
// EXAMPLE: Link your Google Business Profile account. If you do not have a Google Business Profile account, you must first create one on Google Business Profile.
export const EXTERNAL_ACCOUNTS_LINK_ACCOUNT_MESSAGE = publisherName => yext.msg(
  'Link your {0} account. If you do not have a {0} account, you must first create one on {0}.',
  publisherName);
// TRANSLATORS: The argument is the name of a publisher
// EXAMPLE: If you do not link an account, you will not be able to manage your Google Business Profile listings.
export const EXTERNAL_ACCOUNTS_LINK_HELP = publisherName => yext.msg(
  'If you do not link an account, you will not be able to manage your {0} listings.',
  publisherName);
export const EXTERNAL_ACCOUNTS_LIST_HEADER = yext.msg('Linked Accounts');
export const EXTERNAL_ACCOUNTS_MOBILE_LIST_HEADER = yext.msg('The selected account will be linked');
export const EXTERNAL_ACCOUNTS_TAB_LABEL = yext.msg('Linked Accounts');
export const LINK_NEW_ACCOUNT_BUTTON = yext.msg('+ Linked Account');
export const LINK_ORG_ACCOUNT_BUTTON = yext.msg('Link Org Account');
export const LINK_ANOTHER_NEW_ACCOUNT_BUTTON = yext.msg('+ Add Another');
export const NO_EXTERNAL_ACCOUNTS_HEADING = yext.msg('No Linked Accounts');
export const PUBLISHER_ICON_ALT_TEXT = yext.msg('Publisher Icon');
export const UNKNOWN_ERROR = yext.msg(
  'An unknown error occurred. Please try again in a bit.');
export const NO_MANAGE_LINKED_ACCOUNT_PERMISSION_ERROR = yext.msg(
  'You do not have the proper user role permissions to link an account.');
